import TomSelect from "tom-select";
import "tom-select/dist/css/tom-select.default.min.css";

const instances = new WeakMap();

export default class CustomSelect {
    /**
     * @param {HTMLElement} element - Нативний тег <select>
     * @param {Object} options - Додаткові налаштування TomSelect
     */
    constructor(element, options = {}) {
        if (!element) return;
        this.element = element;

        if (element.tomselect) {
            this.instance = element.tomselect;
            return;
        }

        const noResults = globalThis.agds?.i18n?.noResults;
        const defaultOptions = {
            create: false,
            plugins: element.multiple ? ["remove_button"] : [],
            render: {
                no_results: (data, escape) =>
                    noResults ? `<div class="no-results">${escape(noResults)}</div>` : "",
            },
            onChange: () => {
                this.element.dispatchEvent(new Event("change", { bubbles: true }));
            },
        };

        this.instance = new TomSelect(this.element, {
            ...defaultOptions,
            ...options,
            plugins: options.plugins ?? defaultOptions.plugins,
            render: { ...defaultOptions.render, ...options.render },
        });

        this.instance.on("item_add", () => {
            this.instance.setTextboxValue("");
            this.instance.close();
        });

        this.label = element.closest("label");
        this.handleLabelClick = (event) => {
            if (this.label.contains(element)) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
        this.label?.addEventListener("click", this.handleLabelClick);

        instances.set(element, this);
    }

    /**
     * Initializes form selects in the given DOM scope.
     *
     * @param {Document|Element|DocumentFragment} scope
     * @returns {CustomSelect[]}
     */
    static selectsInit(scope = document) {
        if (!scope?.querySelectorAll) return [];

        const selects = [...scope.querySelectorAll("select")];
        if (scope.nodeType === 1 && scope.matches("select")) {
            selects.unshift(scope);
        }

        const isDocument = scope.nodeType === 9;
        return selects.reduce((initialized, element) => {
            if (isDocument && !element.closest("form") && !element.matches(".js-custom-select")) {
                return initialized;
            }

            if (!element.tomselect) {
                initialized.push(new CustomSelect(element));
            }
            return initialized;
        }, []);
    }

    /**
     * Destroys managed TomSelect instances within the given DOM scope.
     *
     * @param {Document|Element|DocumentFragment} scope
     * @returns {void}
     */
    static destroyWithin(scope) {
        if (!scope?.querySelectorAll) return;

        const selects = [...scope.querySelectorAll("select")];
        if (scope.nodeType === 1 && scope.matches("select")) {
            selects.unshift(scope);
        }

        selects.forEach((element) => {
            const customSelect = instances.get(element);
            if (customSelect) {
                customSelect.destroy();
            } else if (element.tomselect) {
                element.tomselect.destroy();
            }
        });
    }

    /**
     * Знищує інстанс TomSelect.
     * Обов'язково викликати перед видаленням елемента з DOM!
     */
    destroy() {
        if (this.instance) {
            this.instance.destroy();
            this.label?.removeEventListener("click", this.handleLabelClick);
            instances.delete(this.element);
            this.instance = null;
        }
    }
}
